import { combineReducers } from "redux";
import matrizConfig from "./slices/matrizConfig.slice";
import camposDetalhe from "./slices/camposDetalhe.slice";
import detalhesPedido from "./slices/detalhesPedido.slice";

const reducer = combineReducers({
  matrizConfig,
  camposDetalhe,
  detalhesPedido,
});

export default reducer;
